import { useTicketPriorities } from "@jugl-web/domain-resources/tickets/hooks/useTicketPriorities";
import { TicketPriority } from "@jugl-web/rest-api/tickets/models/common-types";
import {
  ListBoxItem,
  ResourcePickerPopover,
  ResourcePickerPopoverProps,
} from "@jugl-web/ui-kit";
import { useMemo } from "react";

interface TicketPriorityPickerPopoverProps
  extends Pick<ResourcePickerPopoverProps<TicketPriority>, "renderTrigger"> {
  priority: TicketPriority;
  onChange: (priority: TicketPriority) => void;
}

export const TicketPriorityPickerPopover = ({
  priority,
  onChange,
  renderTrigger,
}: TicketPriorityPickerPopoverProps) => {
  const { priorities, getPriorityById } = useTicketPriorities();

  const priorityListItems = useMemo<ListBoxItem<TicketPriority>[]>(
    () =>
      priorities.map((priorityItem) => ({
        id: priorityItem.id,
        value: priorityItem.id,
      })),
    [priorities]
  );

  const handleSelect = (newPriority: TicketPriority) => {
    if (newPriority === priority) {
      return;
    }

    onChange(newPriority);
  };

  return (
    <ResourcePickerPopover
      placement="bottom"
      className="w-[312px]"
      items={priorityListItems}
      selectionBehavior={{ mode: "single", canToggle: false }}
      defaultSelectedIds={[priority]}
      itemSize="md"
      spaceBetweenItems="compact"
      renderLabel={(item) => getPriorityById(item.value).label}
      renderStartIcon={(item) => getPriorityById(item.value).icon}
      renderTrigger={renderTrigger}
      onSelect={({ item, onClose }) => {
        handleSelect(item.value);
        onClose();
      }}
    />
  );
};
